import React from 'react';

import AgConfirmationModal from '@/components/common/ModalWindow/AgConfirmationModal';
import { UpliftIndex } from '@/graphql/contracts/_generated_/contracts';
import { useDeleteUpliftIndex } from '../hooks/useDeleteUpliftIndex';

interface DeleteUpliftIndexProps {
  isOpen: boolean;
  onClose: () => void;
  selectedIndex: UpliftIndex;
  selectedRegionName: string | undefined;
  onDeleted: () => void;
}

export default function DeleteUpliftIndexModal({
  isOpen,
  onClose,
  selectedIndex,
  selectedRegionName,
  onDeleted,
}: DeleteUpliftIndexProps) {
  const [deleteUpliftIndex, { loading }] = useDeleteUpliftIndex(selectedRegionName);

  return (
    <AgConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={async () => {
        await deleteUpliftIndex({
          variables: { upliftIndexId: selectedIndex.id! },
        });
        onDeleted();
        onClose();
      }}
      title="Delete Uplift Index"
      confirmText={loading ? 'Deleting...' : 'Delete'}
    >
      <span>Deleting an uplift index will remove it from the system and may significantly impact contract lines.</span>
      <br/>
      <span>Are you sure you want to proceed?</span>
    </AgConfirmationModal>
  );
}
